import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as UploadIcon } from "../../../../../../assets/humbleicons_upload.svg";
import { useForm, Controller, useFormContext } from "react-hook-form";
import { Button } from "reactstrap";

import RHFFileUpload from "../../../../../../components/form/RHFFileUpload";


const UploadRequiredDocument = ({
  setActive,
  setTemporaryOpened

}) => {



  const { control, watch, setValue, formState: { errors }, trigger } = useFormContext();
  const type_of_claim = watch('type_of_claim');
  const travelers = watch('travelers');
  const exp_reimbursement = watch('exp_reimbursement');
  const first_name = watch('personal_details.first_name');
  const last_name = watch('personal_details.last_name');



  const fullName = `${first_name} ${last_name}`

  const handleNext = async () => {
    const fieldsToTrigger = ["boarding_pass", "passport", "travelers"];
    if (type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") {
      fieldsToTrigger.push("baggage_claim");
    }
    if (exp_reimbursement === "yes") {
      fieldsToTrigger.push("additional_documents");
    }

    const isValid = await trigger(fieldsToTrigger);

    if (!isValid) {
      return;
    }

    setActive(c => c + 1);
  };

  const handleBack = () => {
    setActive(c => c - 1);
  };


  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Upload required documents
        </h3>
      </div>
      <div>
        <h4 className="stepper-sub-header" style={{ marginBottom: "5px" }}>
          Upload the following documents for each passenger
        </h4>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "35px" }}>
        <div className="file-a-claim">
          <h6 className="form-sub-header">
            Supported formats: PDF, DOCX, JPG. Max size: 10 MB.
          </h6>

          <h4 style={{ marginTop: "30px", marginBottom: "20px" }}>
            Main Traveler ({fullName})
          </h4>

          <div className="claim-grid">
            <RHFFileUpload
              name={`boarding_pass`}
              label="Boarding Pass"
              withDeleteButton={false}

            />

            <RHFFileUpload
              name={`passport`}
              label="Passport"
              withAsterisk={true}
              rules={{
                required: "Passport is required"
              }}
              withDeleteButton={false}

            />

            <div>
              <RHFFileUpload
                name={`additional_documents`}
                label={
                  exp_reimbursement === "yes"
                    ? "Additional Uploads (Supporting receipts for expenses reimbursement)"
                    : (type_of_claim === "lost/damaged" || type_of_claim === "lost_wages")
                      ? "Claim supporting documents and receipts"
                      : "Additional Uploads"
                }
                multiple={true}
                withAsterisk={exp_reimbursement === "yes"}
                rules={
                  exp_reimbursement === "yes"
                    ? {
                      validate: (val) =>
                        (Array.isArray(val) ? val.length > 0 : !!val) ||
                        "Please upload supporting receipts for your expense reimbursement claim",
                    }
                    : undefined
                }
                withDeleteButton={false}
              />

              {/* {exp_reimbursement === "yes" && (
                <div style={{ marginTop: "8px" }}>
                  <p style={{ color: "#D04244", fontSize: "13px", fontWeight: 600, margin: 0 }}>
                    * Claims without proper supporting receipts will NOT be processed.
                  </p>
                </div>
              )} */}
            </div>


            {(type_of_claim === "lost/damaged" || type_of_claim === "lost_wages") && <RHFFileUpload
              name={`baggage_claim`}
              label="Luggage claim receipt filed in airport with the lost and found office or airline"
              withAsterisk={true}
              rules={{
                required: "Luggage claim receipt is required"
              }}
              withDeleteButton={false}

            />}
          </div>

          {travelers.length > 0 && <h4
            className="stepper-sub-header"
            style={{ marginBottom: "5px", marginTop: "30px" }}
          >
            Additional passenger
          </h4>}

          {
            travelers.length > 0 && travelers?.map((travelers, index) => {
              const fullName = `${travelers?.first_name} ${travelers?.last_name}`
              return (

                <div key={index}>
                  <h4 style={{ marginTop: "30px", marginBottom: "20px" }}>
                    Traveler {index + 2} ({fullName})
                  </h4>

                  <div className="claim-grid">
                    <RHFFileUpload
                      name={`travelers.${index}.boarding_pass`}
                      label="Boarding Pass"
                      withDeleteButton={false}

                    />

                    <RHFFileUpload
                      name={`travelers.${index}.passport`}
                      label="Passport"
                      withAsterisk={true}
                      rules={{
                        required: "Passport is required"
                      }}
                      withDeleteButton={false}

                    />

                    <RHFFileUpload
                      name={`travelers.${index}.additional_doc`}
                      label={
                        exp_reimbursement === "yes"
                          ? "Additional Uploads (Supporting receipts)"
                          : (type_of_claim === "lost/damaged" || type_of_claim === "lost_wages")
                            ? "Claim supporting documents and receipts"
                            : "Additional Uploads"
                      }
                      withDeleteButton={false}
                    />



                  </div>

                </div>
              )
            })
          }





        </div>
      </div>

      <div className="stepper-btn-wrapper">
        <button className="secondary-btn new-back-btn" type="button" onClick={handleBack} >
          Back
        </button>

        <div className="add-btn-wrapper" >

          <button className="secondary-btn" type="button" onClick={() => setTemporaryOpened(true)} >
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>




        </div>
      </div>

    </div>
  );
};

export default UploadRequiredDocument;
